import { render, staticRenderFns } from "./WallDonationBlockItemSettings.vue?vue&type=template&id=deebdbf2"
import script from "./WallDonationBlockItemSettings.vue?vue&type=script&lang=js"
export * from "./WallDonationBlockItemSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports